<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-1">
<p class="half">T<span class="small">RACING</span> Y<span class="small">OUR</span> F<span class="small">AMILY</span> H<span class="small">ISTORY</span> T<span class="small">HROUGH</span> <span class="small">THE</span> C<span class="small">ENSUS</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_Halftitle.vue?3102f058